// src/mocks/handlers/funding/campaignDetailsHandler.ts

import { rest } from 'msw';
import campaignDetails from '@/mocks/data/fundingCampaignDetailsData.json';
import { API_ENDPOINTS } from '@/services/api/endpoints';
import { VITE_MSW_BASE_URL } from '@/config';
import {
  ICampaignDetails,
  ICampaignDetailsResponse,
} from '@/domains/funding/campaigns.types';
import { isAccessTokenExpired } from '@/mocks/lib/authTokenUtils';

export const fundingCampaignDetailsHandler = rest.get<ICampaignDetailsResponse>(
  `${VITE_MSW_BASE_URL}${API_ENDPOINTS.FUNDING_CAMPAIGNS_DETAILS}`,
  (req, res, ctx) => {
    const token = req.headers.get('Authorization');
    if (!token) {
      return res(ctx.status(500), ctx.json({ detail: 'Something went wrong' }));
    }

    if (isAccessTokenExpired()) {
      return res(ctx.status(401), ctx.json({ error: 'Access token expired' }));
    }

    const { campaign_uuid } = req.params as { campaign_uuid: string };

    const mockResponse = campaignDetails.find(
      (campaign) => campaign.uuid === campaign_uuid,
    ) as ICampaignDetails | undefined;

    if (!mockResponse) {
      return res(
        ctx.status(404),
        ctx.json({ detail: 'Campaign details not found' }),
      );
    }
    return res(ctx.status(200), ctx.json(mockResponse));
  },
);
